import { createInjectionKey as o } from "./highrise529.mjs";
const n = o("n-button-group");
export {
  n as buttonGroupInjectionKey
};
